const getApiUrl = () => process.env.NODE_ENV === "development" ? "http://localhost:5000" : "https://abernethy-apis.azurewebsites.net"
export default getApiUrl